(function($) {
  $(document).ready(function() {
    $(".mainheader__burger-button").click(function(e) {
      e.preventDefault();
      $(".mainheader__burger-button").toggleClass("mainheader__burger-button--active");
      $(".mainheader__menu").toggleClass("mainheader__menu--active");
      $(".mainheader__menuoverlay").fadeToggle(200);
      $(".mainheader__burger").toggleClass("mainheader__burger--active");
    });

    $(".mainheader__menuoverlay").click(function() {
      // Don't toggle, just close
      $(".mainheader__burger-button").removeClass("mainheader__burger-button--active");
      $(".mainheader__menu").removeClass("mainheader__menu--active");
      $(".mainheader__menuoverlay").fadeOut(200);
      $(".mainheader__burger").removeClass("mainheader__burger--active");
    });

    $("li.menu-item").on("click", function() {
      if ($(this).hasClass("menu-item-has-children")) {
        $(this).toggleClass("menu-item--active");
      }
    });
  });
}(jQuery));